import { ApiBase } from '@/api/api'
import { makePatchRequest } from '@/api/fetchCalls'
import { Answer } from '@/types/answer'

export const updateAnswerById = async ({
  id,
  ...data
}: Partial<Answer>): Promise<void> => {
  return makePatchRequest(ApiBase + `/answers/${id}`, {
    body: JSON.stringify(data),
  })
}
